import React from "react";
import favoriteReducer from "../reducers/favorite";
import { favorite, requestState } from "../actions";
import axios from "axios";
const FavoriteContext = React.createContext();
export const FavoriteProvider = ({ children }) => {
	const initialState = {
		favorites: [],
		loading: false,
		error: null,
		success: null,
		favoriteFilter: null,
	};

	const [favoriteState, dispatch] = React.useReducer(favoriteReducer, initialState);

	const isLoading = () => {
		dispatch({
			type: requestState.LOADING,
		});
	};

	//Get  user favorites
	const getFavorites = async () => {
		try {
			const res = await axios.get("/favorites");
			dispatch({
				type: favorite.GET_FAVORITES,
				payload: res.data,
			});
		} catch (error) {
			dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message : "Connection failed" || error.message,
			});
		}
	};

	//Add  to favorites
	const addToFavorite = async (_id) => {
		try {
			const res = await axios.post("/favorites", { user: localStorage.getItem("_id"), lesson: _id });
			dispatch({
				type: favorite.ADD_TO_FAVORITE,
				payload: res.data,
			});
		} catch (error) {
			dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message : "Connection failed" || error.message,
			});
		}
	};

	const filterFavorite = (value) => {
		dispatch({
			type: favorite.FILTER_FAVORITE,
			payload:value
		});
	};

	const clearFilter = () => {
		dispatch({
			type: favorite.CLEAR_FILTER,
		});
	};

	const removeFromFavorite = async (_id) => {
		try {
			const res = await axios.delete(`/favorite/${_id}`);
			dispatch({
				type: favorite.REMOVE_FROM_FAVORITE,
				payload: res.data,
			});
		} catch (error) {
			console.log(error.response);
			dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message : "Connection failed" || error.message,
			});
		}
	};
	// Clear Errors
	const clearNotification = () =>
		dispatch({
			type: requestState.CLEAR_NOTIFICATION,
		});
	return (
		<FavoriteContext.Provider
			value={{
				loading: favoriteState.loading,
				error: favoriteState.error,
				clearNotification: clearNotification,
				isLoading: isLoading,
				success: favoriteState.success,
				getFavorites: getFavorites,
				favorites: favoriteState.favorites,
				addToFavorite: addToFavorite,
				removeFromFavorite: removeFromFavorite,
				filterFavorite: filterFavorite,
				favoriteFilter: favoriteState.favoriteFilter,
				clearFilter: clearFilter,
			}}
		>
			{children}
		</FavoriteContext.Provider>
	);
};

export const useFavoriteContext = () => React.useContext(FavoriteContext);
